import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (sessionStorage.getItem('token') === null) {
    router.navigate(['/login']);
    return false;
  }

  return authService.isTermsAccepted().pipe(
    map((accepted) => {
      if (!accepted) {
        router.navigate(['/login']);
        return false;
      }
      return true;
    }),
  );
};
